import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '../types';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;

  setUser: (user: User | null) => void;
  setToken: (token: string | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      setUser: (user) => set({ user, isAuthenticated: !!user }),

      setToken: (token) => {
        if (token) {
          localStorage.setItem('product_dashboard_token', token);
        } else {
          localStorage.removeItem('product_dashboard_token');
        }
        set({ token });
      },

      logout: () => {
        localStorage.removeItem('product_dashboard_token');
        set({ user: null, token: null, isAuthenticated: false });
      },
    }),
    {
      name: 'product-dashboard-auth',
      partialize: () => ({}),
    }
  )
);
